import { render } from "./help-links-sidebar.vue?vue&type=template&id=20f6af42"
const script = {}

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__